<template>
  <v-container style="padding-top: 20px" fluid>
     <v-card class="pa-12">
             <v-card-title>
          <v-row>
            <v-col cols="12" md="6" align="center" justify="center" class="mt-n6">
               <v-row>
                  <v-col cols="12" md="12" align="left" justify="left">
              <h3>{{ lg_recording_credits.title }}</h3>
              </v-col>
              </v-row>
               <v-row>
                  <v-col cols="12" md="12" align="left" justify="left" class="mt-n2">
              <h5 v-bind:style="{fontWeight:'300 !important' }">{{ lg_recording_credits.title1 }}</h5>
              </v-col>
              </v-row>
            </v-col>
           
          <v-col cols="12" md="6" align="right" justify="right" class="mt-n6">
               <v-row>
                  <v-col cols="12" md="12" align="right" justify="right" >
              <h5 v-bind:style="{fontWeight:'500 !important' }">  
                <v-icon color="#3E73BB">mdi-package</v-icon> 
                {{ `${account?account.acc_plan:""} ${lg_recording_credits.monthly}` }}</h5>
              </v-col>
               <!-- <v-col cols="12" md="5" align="right" justify="right" >
              </v-col> -->
              </v-row>
               <v-row>
                  <v-col cols="12" md="7" align="right" justify="right" class="mt-n2">
              <h5 v-bind:style="{fontWeight:'500 !important' }">  
                 <v-icon color="#3E73BB">mdi-calendar</v-icon> 
                 {{ lg_recording_credits.month }} </h5>
              </v-col>
                  <v-col cols="12" md="5" align="right" justify="right" class="mt-n2">
              <v-menu
            v-model="dateMenuVisible"
            :close-on-content-click="false"
            max-width="290"
          >
          <!--  :value="renderDateSearch" -->
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                class=""
                v-model="dateSearchformat"
                outlined
                readonly
                dense
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              type="month"
              :max="dateyearmonthformat"
              v-model="dateSearch"
              @change="dateMenuVisible = false"
            ></v-date-picker>
          </v-menu>
              </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>

   
              <v-row class="mx-2">
              <v-col cols="12" md="12" align="left" justify="left" class="mt-6">
              <h2>{{ `${lg_recording_credits.monthly_usage_summary}` }}</h2>
              </v-col>
              </v-row>

             <v-row class="mx-2">
              <v-col cols="12" md="2" align="left" justify="left" class="mt-6">
              <h2 v-bind:style="{fontWeight:'500 !important' }">{{ `${lg_recording_credits.used}` }}</h2><br/>
              <h3>{{ `${used} ${lg_recording_credits.minutes}` }}</h3>
              </v-col>
               <v-col cols="12" md="2" align="left" justify="left" class="mt-6">
              <h2 v-bind:style="{fontWeight:'500 !important' }">{{ `${lg_recording_credits.remaining}` }}</h2><br/>
              <h3 style="color:green">{{ `${total-used} ${lg_recording_credits.minutes}` }}</h3>
              </v-col>
               <v-col cols="12" md="2" align="left" justify="left" class="mt-6">
              <h2 v-bind:style="{fontWeight:'500 !important' }">{{ `${lg_recording_credits.total_quota}` }}</h2><br/>
              <h3>{{ `${total} ${lg_recording_credits.minutes}` }}</h3>
              </v-col>
               <v-col cols="12" md="2" align="left" justify="left" class="mt-6">
              <h2 v-bind:style="{fontWeight:'500 !important' }">{{ `${lg_recording_credits.reset_date}` }}</h2><br/>
              <h3>{{ `${fistdateofnextmonth}` }}</h3>
              
              </v-col>
                <v-col cols="12" md="4" align="center" justify="center" class="mt-md-n12">
<div style="position:relative;width:180px; height:150px;">
    <!-- วงเทา -->
    <v-progress-circular
      :value="100"
      size="150"
      width="12"
      color="grey lighten-2"
       style="position:absolute; top:0; left:0;"
    ></v-progress-circular>

    <!-- วงแดง (ค่าใช้งาน) -->
    <v-progress-circular
      :value="percentage"
      size="150"
      width="12"
      color="red"
      rotate="-90"
      style="position:absolute; top:0; left:0;"
    ></v-progress-circular>

    <!-- ข้อความกลาง -->
    <div
      style="position:absolute; top:55%; left:50%; transform:translate(-50%, -50%); text-align:center;"
    >
      <div>Recording Quota</div>
      <div style="font-size:20px; font-weight:bold;">{{ used }}/{{ total }}</div>
      <div>{{ percentage?percentage:0 }}% used</div>
    </div>
  </div>
  </v-col>
              </v-row>

                 <v-row>
              <v-col cols="12" md="8" align="left" justify="left" class="">
                <v-progress-linear
      :value="percentage"
      background-color="success"
      color="error"
      height="12"
      rounded
    ></v-progress-linear>
              </v-col>
               <!-- <v-col cols="12" md="4" align="center" justify="center" class="mt-md-n12">

               </v-col> -->

              </v-row>

                              <v-row class="mx-2" v-if="total-used <= alertlowcredit">
              <v-col cols="12" md="12" align="left" justify="left" class="mt-6">
            
                <v-card outlined color="#F8E5C8" :elevation="0" style="border-color: #FDCA7D;">
                  <v-card-title> 
                    <h5>{{ lg_recording_credits.low_credit_warning }}</h5> 
                  </v-card-title>
                      <v-card-text class="body">
        {{ lg_recording_credits.low_credit_warning_details }}
      </v-card-text>
                </v-card>
              </v-col>
              </v-row>


                <v-row class="mx-2">
              <v-col cols="12" md="12" align="left" justify="left" class="mt-6">
              <h3>{{ `${lg_recording_credits.recording_logs}` }}</h3>
              </v-col>
              </v-row>
    <v-data-table
      :headers="lg_recording_credits.headers"
      :items="desserts"
      class="elevation-1"
      :loading="loading"
      :items-per-page="itemsPerPage"
    >     

      <template v-slot:item.recording_duration="{ item }">
       {{ (item.recording_duration/60).toFixed(2) }}
      </template>


      <template v-slot:item.action="{ item }">
        <v-btn
        v-if="item.status == 'UPLOADED'"
            color="#3E73BB"
            class="rounded-pill"
            dark
           @click="Downloaditemrecording(item)"
            style="margin: auto;"
          >
          {{ lg_recording_credits.download}}
          </v-btn>
         <p v-if="item.status == 'ERRORED'"> {{ lg_recording_credits.unavailable}}</p>
      </template>

        <template v-slot:item.status="{ item }">
         <p v-if="item.status == 'UPLOADED'" style="color: green;"> {{ lg_recording_credits.saved_successfully}}</p>
         <p v-if="item.status == 'ERRORED'" style="color: red;"> {{ lg_recording_credits.failed}}</p>
       </template>

      <template v-slot:item.index="{ item,index }">
        {{ index+1}}
      </template>

      <!-- <template v-slot:item.started_time="{ item }">
        {{ new Date(item.started_time).toLocaleString('en-US', { timeZone: "Asia/Bangkok" })  }}
      </template> -->

      <template v-slot:item.stopped_time="{ item }">
        {{ new Date(item.stopped_time).toLocaleString('en-US', { timeZone: "Asia/Bangkok" })  }}
      </template>

      <template v-slot:item.createdAt="{ item }">
        {{ item.createdAt | dateFormat }}
      </template>
    </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import firebase from "firebase/app";
import api from "@/services/api";
import moment from "moment";
import { format, parseISO } from "date-fns";
import { server ,apiUrlRecord} from "../services/constants";
import { feature } from "../services/constants";
import { lg_recording_credits } from "./language/lg_recording_credits";

export default {
  data: () => ({
    fistdateofnextmonth:format(new Date(new Date().getFullYear(),new Date().getMonth() + 1, 1), "dd MMMM yyyy"),
    account:null,
    itemsPerPage:10,
    setdatavoteshow: 0,
    desserts:[],
    votes: [],
    setdatavote: "",
    topicSearch: null,
    dateMenuVisible: false,
    dateSearch: new Date().toISOString().substr(0, 7),
    dateSearchformat: format(parseISO(new Date().toISOString().substr(0, 7)), "MMMM yyyy"),
    dateyearmonthformat: format(parseISO(new Date().toISOString().substr(0, 7)), "yyyy-MM "),
    loading: false,
    pdfDialog: false,
    pdfBytes: null,
    userRole: null,
    company_id: null,
    used: 0,
    total: 0,
    alertlowcredit:5,
  }),
  components: {
  },
   watch:{
  async dateSearch(newvalue){
    this.dateSearchformat = format(parseISO(this.dateSearch), "MMMM yyyy");
    await this.fetchDataRecording();
    },
  },
  computed: {
    renderDateSearch() {
      return this.dateSearch
        ? format(parseISO(this.dateSearch), "MMMM yyyy")
        : "";
    },
    reports() {
      const { votes, topicSearch, dateSearch } = this;
      const reports = votes.filter((v) => {
        const { createdBy, topic, createdAt,meeting,started_time } = v;
        const validTopic =
          topicSearch?.length > 0
            ? meeting.title?.toLowerCase()?.includes(topicSearch?.toLowerCase())
            : true;

        const validDate = dateSearch
          ?  new Date(started_time).toLocaleDateString('en-CA') &&
          new Date(started_time).toLocaleDateString('en-CA') ===
          dateSearch
          : true;
        return validTopic && validDate;
      });
      // console.log(reports)

      return reports;
    },
  },
  methods: {
  async  downloadFile(url, filename) {
      try {
        const response = await fetch(url);
        if(!response.ok){
            this.$swal.fire("Error",`Download Failed`, "error");
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        // if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        
        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.download = filename || 'video.mp4';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        
        // Release memory
        URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.error('Error downloading file:', error);
    }
    },
    async Downloaditemrecording(item) {
      //  console.log(item);
      //  window.location.replace(item.download_url);
      // window.location.replace(`${apiUrlRecord}/${item.output_file_name}`);
      //  this.downloadFile(`${apiUrlRecord}/${item.output_file_name}`, `${item.output_file_name}`);
        this.downloadFile(`https://apidtime.dcm.co.th/api_dmeets_prod/record/${item.output_file_name}`, `${item.output_file_name}`);
      
    },
    async fetchMembers() {
      const snapshot = await firebase.firestore().collection("members").get();
      const { docs } = snapshot;
      return docs.map((d) => d.data());
    },
    async fetchDataRecording() {
         this.$swal.fire({
  title: 'Loading...',
  text: '',
  allowOutsideClick: false,
  didOpen: () => {
    this.$swal.showLoading()
  }
});
      this.desserts = [];
      this.used = 0;
      try {
        this.loading = true;
        let result;
        let role = localStorage.getItem(server.ROLE);
        let userId = localStorage.getItem(server.USER_ID)?localStorage.getItem(server.USER_ID):0;
        // if (role == "Admin") {
        //   result= await api.getMeetingRecordall();
        // }else{

    const year = parseInt(this.dateSearch.split("-")[0]);
const month = parseInt(this.dateSearch.split("-")[1]) - 1; 
// วันแรกของเดือน
const firstDate = new Date(year, month, 1);
// วันสุดท้ายของเดือน
const lastDate = new Date(year, month + 1, 0);

const getfirstDate = await this.formatDateFirstandLast(firstDate);
const getlastDate = await this.formatDateFirstandLast(lastDate);

       
          result= await api.getMeetingRecordbyid(userId,{firstdate:getfirstDate,lastdate:getlastDate});
        // }

      if(result.status == 401){
      this.$store.state.loadMenu = false;
       this.$store.dispatch("doLogout");
        return;
      }
      if(result.data.length > 0){
        result.data.forEach((x,i)=>{
          this.used += Number((x.recording_duration/60).toFixed(2));
          if(i == result.data.length-1){
            this.used =  Number(this.used.toFixed(2));
          }
        });
   
      this.desserts = result.data;
           this.desserts.forEach((x,i)=>{
          x.started_time =  format(parseISO(x.started_time), "dd MMM yy hh:mm a");
        });
      }
     
        this.$swal.close();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$swal.close();

        this.$swal.fire("Error", error.message, "error");
      }
    },
  async formatDateFirstandLast(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
  },
  computed: {
    percentage() {
      return Math.round((this.used / this.total) * 100);
    },
  },
  beforeCreate() {
    if (api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login-account");
    }
    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_recording_credits = lg_recording_credits.lg_recording_credits_th)
      : (this.lg_recording_credits = lg_recording_credits.lg_recording_credits_en);
  },
   async mounted() {
    this.$store.state.loadFooter = false;
    if (localStorage.getItem(server.ROLE) == "FREE") {
      this.$router.push("/");
    }
    const result = await api.getAccountById(localStorage.getItem("user_id"));
    this.account = result.data;
    this.total =  (this.account.recording_per_month/60);
      if (api.isLoggedIn()) {
     await this.fetchDataRecording();

    }
  },
  async created() {
  
  },
};
</script>

<style>
.vertical-top-row > .v-data-table__wrapper > table > tbody > tr {
  vertical-align: text-top;
}

.title-wrapper {
  text-align: center;
  margin-bottom: 20px;
}

.page-title {
  font-size: 20px;
  margin-bottom: 10px;
}

.page-sub-title {
  font-weight: 400;
}
/*
.apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {
    display: block;
}
.apexcharts-xaxis-title{
  font-size:12px;
}
*/
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  height: 85px;
}
</style>
